import { UserInterface } from "@swivl-mono/types";
import { Button, ButtonColor, ButtonSize, ButtonVariant, Input } from "@swivl-mono/ui";
import { motion } from "motion/react";
import { FormEvent, MouseEvent, memo } from "react";

interface BaseQuickEditFormProps {
  user: UserInterface;
  handleCancelEdit: () => void;
  handleSetIsEditing: () => void;
  handleEditUser: (updatedUser: Partial<UserInterface>) => void;
}

const BaseQuickEditForm = ({ user, handleCancelEdit, handleSetIsEditing, handleEditUser }: BaseQuickEditFormProps) => {
  const handleEdit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);

    const name = formData.get("name") as string | null;
    const phoneNumber = formData.get("phone") as string | null;
    const email = formData.get("email") as string | null;

    const updatedUser: Partial<UserInterface> = {
      id: user.id,
      name: name || undefined,
      phoneNumber: phoneNumber || undefined,
      email: email || undefined
    };

    handleEditUser(updatedUser);
  };

  const handleShowMoreClick = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    handleSetIsEditing();
  };

  const handleDiscardClick = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    handleCancelEdit();
  };

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
      <form onSubmit={handleEdit} className="flex flex-col gap-2">
        {/* <div className="flex w-full gap-4"> */}
        <Input label="Name" id="name" name="name" defaultValue={user?.name} />
        {/* <div className="flex w-1/2 flex-col gap-1">
            <label className="body-sm" htmlFor="lastName">
              Last Name
            </label>
            <Input id="lastName" name="lastName" defaultValue={user?.lastName} />
          </div> */}
        {/* </div> */}
        <Input label="Phone" id="phone" name="phone" defaultValue={user?.phoneNumber} />
        <Input label="Email" id="email" name="email" defaultValue={user?.email} />
        <div className="flex justify-between gap-2">
          <Button onClick={handleShowMoreClick} variant={ButtonVariant.GHOST} type="button">
            Show More
          </Button>
          <div className="flex gap-2">
            <Button onClick={handleDiscardClick} variant={ButtonVariant.GHOST} size={ButtonSize.SMALL} type="button">
              Discard
            </Button>
            <Button color={ButtonColor.ORANGE} size={ButtonSize.SMALL} type="submit">
              Save
            </Button>
          </div>
        </div>
      </form>
    </motion.div>
  );
};

export const QuickEditForm = memo(BaseQuickEditForm);
